import { Outlet, useLocation } from "react-router-dom";
import { UserMenu } from "./UserMenu";
import { APP_ROUTES } from "../routes";

export function AppShell() {
  const location = useLocation();
  const useConversationShell =
    location.pathname.startsWith(APP_ROUTES.datascope) ||
    location.pathname.startsWith(APP_ROUTES.pinboards);

  return (
    <div className="flex h-dvh max-w-dvw overflow-hidden bg-background">
      {!useConversationShell ? (
        <div className="shrink-0">
          <UserMenu />
        </div>
      ) : null}
      <main className="min-w-0 flex-1 overflow-y-auto bg-background">
        <Outlet />
      </main>
    </div>
  );
}
